import React from "react";
import { Link } from "react-router-dom";
import { PageHeader } from "@/pages/About";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { FileText, ClipboardList, UploadCloud, CreditCard, UserCheck, Award, ShieldCheck, RefreshCw } from "lucide-react";
import { ReviewTimeline } from "@/components/ReviewTimeline";

const steps = [
  { icon: FileText, t: "1. Apply Online", d: "Create an account and submit your company profile: legal name, website, contact, country, industry, size, site type, customer industries, and requested certification level." },
  { icon: ClipboardList, t: "2. Complete the Questionnaire", d: "Answer structured questions across your selected categories. Indicate your maturity level and add notes describing your controls." },
  { icon: UploadCloud, t: "3. Upload Documents", d: "Provide evidence across up to 56 document categories — policies, procedures, records, permits, training logs, AI governance evidence, and screening evidence. You can upload multiple files per topic." },
  { icon: CreditCard, t: "4. Submit & Pay", d: "Submit your application and pay the certification fee securely by credit card or ACH bank transfer. Once payment is confirmed, your application moves to Paid / Ready for Review and enters the review queue." },
  { icon: UserCheck, t: "5. Document Review", d: "A WECH-RB reviewer verifies your evidence against the Code of Conduct — supported by an internal AI-assisted gap analysis — adjusts scores, and adds comments. If any documents are missing or unclear, our team will contact you to confirm whether they can be provided before a final decision." },
  { icon: Award, t: "6. Certification Decision", d: "If approved, your certification level (Silver, Gold, or Platinum) is confirmed and a certificate is issued with an expiration date. Certificates are issued only after payment and reviewer approval." },
  { icon: ShieldCheck, t: "7. Public Verification", d: "Your certificate carries a unique ID and QR code and is publicly verifiable by buyers and partners." },
  { icon: RefreshCw, t: "8. Ongoing Monitoring", d: "Certificates can be renewed, and may be suspended or revoked if standards are no longer met." },
];

const CertificationProcess = () => (
  <div>
    <PageHeader eyebrow="Certification Process" title="A clear, document-reviewed path to certification"
      subtitle="No on-site audit required for the first version. Everything is completed online through evidence and document review across six categories — including AI governance, security & responsible use." />
    <section className="wechr-section">
      <div className="wechr-container">
        <div className="relative space-y-4">
          {steps.map((s) => (
            <Card key={s.t}>
              <CardContent className="flex gap-5 p-6">
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-wgreen-100"><s.icon className="h-6 w-6 text-wgreen-700" /></div>
                <div>
                  <h3 className="font-heading text-base font-semibold text-navy-900">{s.t}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-[var(--wechr-muted-text)]">{s.d}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
        <ReviewTimeline className="mt-14" />
        <div className="mt-10 flex justify-center">
          <Link to="/apply"><Button size="lg" className="btn-green">Start your application</Button></Link>
        </div>
      </div>
    </section>
  </div>
);

export default CertificationProcess;
